import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Michael Johnson',
      business: 'Johnson Construction',
      rating: 5,
      text: 'Sue has been handling our books for over 2 years. Her attention to detail and expertise with QuickBooks has saved us countless hours and headaches. Highly recommended!'
    },
    {
      name: 'Sarah Chen',
      business: 'Chen Marketing Agency',
      rating: 5,
      text: 'Working with Wisdomwares has been a game-changer for our business. Sue is professional, reliable, and always available when we need her. Our financial reports are always accurate and on time.'
    },
    {
      name: 'Robert Williams',
      business: 'Williams Consulting',
      rating: 5,
      text: 'I was struggling with QuickBooks until Sue came to the rescue. She not only cleaned up our books but also trained our staff. Outstanding service and expertise!'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it - hear from satisfied clients who trust 
            Wisdomwares with their financial records
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              {/* Stars */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="h-5 w-5 text-yellow-400 fill-current" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-600 mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Client Info */}
              <div className="border-t pt-4">
                <h4 className="font-bold text-gray-900">
                  {testimonial.name}
                </h4>
                <p className="text-blue-600 font-medium">
                  {testimonial.business}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="text-lg text-gray-600 mb-6">
            Ready to join our satisfied clients?
          </p>
          <a
            href="#contact"
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 inline-block"
          >
            Get Started Today
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;